<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :persistenceKey="'Product-list'"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";

import TransactionListTemplate from "../../templates/transaction-list";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {};
  },
  computed: {
    setScreenConfig() {
      var config = {
        title: "Products",
        exportFileName: "Products List",
        selectedIndex: 0,
        tabs: [
          {
            text: "All",
            path: `/product`,
            applicationFeatureCode: "Product",
          },
          {
            text: "Stock Summary",
            path: `/stock-summary`,
            applicationFeatureCode: "StockSummary",
          },
          {
            text: "Item Movements",
            path: `/item-movements`,
            applicationFeatureCode: "ItemMovements",
          },
        ],
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "ProductList",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
              keyType: {
                Attribute01: "Guid",
                Attribute02: "Guid",
                Attribute03: "Guid",
                Attribute04: "Guid",
                Attribute05: "Guid",
                Attribute06: "Guid",
                Attribute07: "Guid",
                Attribute08: "Guid",
                Attribute09: "Guid",
                Attribute10: "Guid",
                Attribute11: "Guid",
                Attribute12: "Guid",
                Attribute13: "Guid",
                Attribute14: "Guid",
                Attribute15: "Guid",
                Attribute16: "Guid",
                Attribute17: "Guid",
                Attribute18: "Guid",
                Attribute19: "Guid",
                Attribute20: "Guid",
              },
            },
            // rowSelect: {
            //   view: this,
            //   page: "sales-order",
            //   mode: "review",
            //   idProperty: "Code",
            // },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Products",
                message: "Get Started, Add a Product",
              },
            },
          },

          toolbar: {
            search: false,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/product/create",
                clickAction: {},
                buttonLocation: "left",
              },
            ],
          },
          columns: [
            {
              screenField: "Item",
              label: "Product",
              gridDataField: "Description1",
              sortOrder: "asc",
              sortIndex: 0,
              allowHiding: false,
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "Description1",
                  },
                ],
                secondary: [
                  {
                    dataField: "Code",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "Code",
                  label: "Item Code",
                },
                {
                  dataField: "Description1",
                  label: "Item Description 1",
                },
                {
                  dataField: "Description2",
                  label: "Item Description 2",
                },
                {
                  dataField: "Description3",
                  label: "Item Description 3",
                },
              ],
              fixed: true,
              fixedPosition: "left",
            },
            {
              screenField: "Code",
              label: "Product Code",
              filterLabel: "Product Code",
              dataField: "Code",
              showInColumnChooser: false,
              visible: false,
              type: "Text",
            },
            {
              screenField: "Name",
              filterLabel: "Product",
              filterDataField: "ProductSearchText",
              showInColumnChooser: false,
              visible: false,
              type: "Text",
              filterIndex: 1,
            },
            {
              screenField: "ProductCategory1",
              label: "Category 1",
              filterLabel: "Category 1",
              filterIndex: 3,
            },
            {
              screenField: "ProductCategory2",
              label: "Category 2",
              filterLabel: "Category 2",
              filterIndex: 4,
            },
            {
              screenField: "ProductCategory3",
              label: "Category 3",
              filterLabel: "Category 3",
              filterIndex: 5,
            },
            {
              screenField: "ProductCategory4",
              label: "Category 4",
              filterLabel: "Category 4",
              filterIndex: 6,
            },
            {
              screenField: "ProductType",
              label: "Type",
              filterLabel: "Type",
              filterIndex: 7,
            },
            {
              screenField: "ProductSize",
              label: "Size",
              filterLabel: "Size",
              filterIndex: 8,
            },
          ]
            .concat(this.getAttributeColumns())
            .concat({
              screenField: "Status",
              gridDataField: "Inactive",
              gridLabel: "Status",
              filterIndex: 2,
              filterDefaultValue: ["N"],
            }),
        },
      };

      return config;
    },
  },
  methods: {
    getAttributeColumns() {
      const records = [];

      for (let i = 1; i <= 20; i++) {
        const record = {
          screenField: `ProductAttribute${i.toString().padStart(2, "0")}`,
          label: `Attribute ${i.toString().padStart(2, "0")}`,
          filterLabel: `Attribute ${i.toString().padStart(2, "0")}`,
          cellTemplateRecord: {
            primary: [
              {
                dataField: `Attribute${i
                  .toString()
                  .padStart(2, "0")}Description`,
              },
            ],
            secondary: [
              {
                dataField: `Attribute${i.toString().padStart(2, "0")}Code`,
              },
            ],
          },
          exportFields: [
            {
              dataField: `Attribute${i.toString().padStart(2, "0")}Code`,
              label: `Attribute ${i.toString().padStart(2, "0")} Code`,
            },
            {
              dataField: `Attribute${i.toString().padStart(2, "0")}Description`,
              label: `Attribute ${i.toString().padStart(2, "0")} Description`,
            },
          ],
          filterIndex: 9,
          filterDataField: `Attribute${i.toString().padStart(2, "0")}`,
          visible: false
        };

        records.push(record);
      }

      return records;
    },
    rowClickCallBack(e) {
      if (e.rowType == "data" && e.column.screenField != "Status") {
        this.onRowClicked(e, {
          view: this,
          page: "product",
          mode: "review",
          idProperty: "Code",
        });
      }
    },
  },

  created() {},
};
</script>

<style lang="scss"></style>
